import React from 'react';
import { Typography } from '@forgeglobal/design-framework';
import Selector, { SelectorProps } from '@tcs/common/components/atoms/Selector';
import { isEmpty } from 'lodash';

type Props = Omit<SelectorProps, 'labelVariant'>;

export const SubTitleSelector = (props: Props & { title: string }) => {
  const { items } = props;
  if (isEmpty(items)) return null;

  return (
    <div>
      <Typography variant="h4">{props.title}</Typography>
      <br />
      {items.length === 1 ? (
        <Typography variant="h5">{items[0].listItem}</Typography>
      ) : (
        <Selector labelVariant="h5" {...props} />
      )}
    </div>
  );
};

export default SubTitleSelector;
